import React from 'react'
// import Testimonial from './Testimonial'
import Faq from './Faq'
import ConatctForm from './homepage/ConatctForm'
import Testimonial from './homepage/Testimonial'

const Pricing = () => {
  return (
   <>
      {/* TODO : HERO */}
      <section className="hero">
        <p className="hero-subtitle animate-in">Plans That Suit Everyone!</p>
        <h1 className="hero-title animate-in delay-1">
          The Best E-commerce websites that are:
        </h1>
        <div className="hero-tagline animate-in delay-2">
          <span className="word-upgradable">Upgradable<span className="dot">.</span></span>
          <span className="word-affordable">AFForDABLE<span className="dot">.</span></span>
          <span className="word-flexible">Flexible.</span>
        </div>
        <a href="#" className="btn-book animate-in delay-3">Book a Call Now</a>
        <p className="hero-note animate-in delay-4">
          By Booking A Call, You Can Know More About Our Processes.
        </p>
        {/* <span class="hero-confetti">🎉</span> */}
      </section>

      {/* TODO : PRICING */}
      <section className="pricing-section">
        <div className="pricing-grid">
          {/* Premium */}
          <div className="pricing-card animate-in">
            <div className="plan-name">Premium</div>
            <p className="plan-desc">
              Premium Looking Templates with Interactive Components
            </p>
            <div className="plan-price">₹1,249<span>/mo</span></div>
            <p className="plan-billing">*Billed on an yearly basis</p>
            <div className="plan-check">
              Including all design, development, marketing and management
              features.
            </div>
          </div>
          {/* Advanced (Featured) */}
          <div className="pricing-card featured animate-in delay-1">
            <div className="most-popular-badge">Most Popular</div>
            <div className="plan-name">Advanced</div>
            <p className="plan-desc">
              Advanced Templates with Interactive Components
            </p>
            <div className="plan-price">₹999<span>/mo</span></div>
            <p className="plan-billing">*Billed on an yearly basis</p>
            <div className="plan-check">
              Including all design, development, marketing and management
              features.
            </div>
          </div>
          {/* Basic */}
          <div className="pricing-card animate-in delay-2">
            <div className="plan-name">Basic</div>
            <p className="plan-desc">Basic Templates at affordable cost</p>
            <div className="plan-price">₹599<span>/mo</span></div>
            <p className="plan-billing">*Billed on an yearly basis</p>
            <div className="plan-check">
              Including all design, development, marketing and management
              features.
            </div>
          </div>
          {/* Custom */}
          <div className="pricing-card animate-in delay-3">
            <div className="plan-name">Custom</div>
            <p className="plan-desc">
              For custom projects or templates, contact us for different pricing
            </p>
            <button className="btn-contact-plan">Contact Us</button>
            <p className="plan-call">Or call us at +91 XXXXXXXX</p>
            <div className="plan-check">
              Including all design, development, marketing and management
              features.
            </div>
          </div>
        </div>
        <p className="pricing-note">
          *AxeSell plans are based on template styles, all other features offered
          are the same in every plan.
        </p>
      </section>

      
      {/* TODO : ALL PLANS INCLUDE */}
      <section className="plans-include">
        <h2 className="plans-include-title">
          All <em>Plans</em> <span>INCLUDE:</span>
        </h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24">
                <circle cx={12} cy={8} r={4} />
                <path d="M20 21a8 8 0 10-16 0" />
                <path d="M12 12v9" />
                <path d="M8 17l4 4 4-4" />
              </svg>
            </div>
            <div className="feature-name">System Management</div>
            <p className="feature-desc">
              Manage all users, products, store, and orders all at the same place.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24">
                <rect x={3} y={3} width={8} height={8} rx={1} />
                <rect x={13} y={3} width={8} height={8} rx={1} />
                <rect x={3} y={13} width={8} height={8} rx={1} />
                <rect x={13} y={13} width={8} height={8} rx={1} />
              </svg>
            </div>
            <div className="feature-name">User Panel</div>
            <p className="feature-desc">
              Customers or users can manage their profile, set new passwords or
              track their orders using the user dashboard.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24">
                <circle cx={12} cy={12} r={10} />
                <path d="M12 8v4l3 3" />
                <path d="M8 12h8" />
              </svg>
            </div>
            <div className="feature-name">SEO Marketing</div>
            <p className="feature-desc">
              We offer extensive SEO services catering exclusively to eCommerce
              businesses seeking to drive traffic.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
              </svg>
            </div>
            <div className="feature-name">24/7 Assistance</div>
            <p className="feature-desc">
              We are available 24/7 in case of any technical or non technical
              support you might need.
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24">
                <circle cx={12} cy={12} r={10} />
                <line x1={2} y1={12} x2={22} y2={12} />
                <path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" />
              </svg>
            </div>
            <div className="feature-name">Domain</div>
            <p className="feature-desc">
              You can opt for a domain from us or transfer any other domain that
              you would like to use.
            </p>
          </div>
        </div>
        <a href="contact.html" className="btn-know-more">Call to Know More</a>
      </section>
      <Testimonial />
      <Faq />
      <ConatctForm />
   </>
  )
}

export default Pricing